/** @file wrapSignedDegrees: an angle in degrees wrapped into [-180, 180) (design 21 `wrap`). */
import { wrapDegrees } from '@zilo/pose3d-std/math/wrapDegrees';

/** `deg` wrapped into [-180, 180): 180 becomes -180, as section 21's `wrap` reads. */
export function wrapSignedDegrees(deg: number): number {
  const w = wrapDegrees(deg);
  return w >= 180 ? w - 360 : w;
}
